"use client"

import {useTranslations} from "next-intl";
import {cn} from "@/lib/utils";
import {getApkUrl} from "@/lib/utils/appLink";
import {AndroidSvg} from "@/app/components/icons/AndroidSvg";
import {DownloadSvg} from "@/app/components/icons/DownloadSvg";
import {useApkDownload} from "@/hooks/use-apk-download";

interface IProps {
    className?: string;
    /** Collapsed desktop sidebar: icon only. */
    compact?: boolean;
}

// Compact APK entry under the language selector (V2 spec §2): desktop sidebar and
// the expanded phone/tablet menu. Figma "App / Sidebar Android download".
export const AppDownloadRow = ({className, compact}: IProps) => {
    const t = useTranslations();
    const apkUrl = getApkUrl();
    const onDownload = useApkDownload();

    if (!apkUrl) return null;

    return (
        <a
            href={apkUrl}
            onClick={onDownload}
            aria-label={compact ? `${t('AppDownload.title')} · ${t('AppDownload.subtitle')}` : undefined}
            className={cn(
                'flex items-center gap-[10px] h-[58px] rounded-[12px] border border-[#5B4930]',
                'bg-[linear-gradient(90deg,#29251D_0%,#1C1B18_100%)] transition-[filter] hover:brightness-110',
                compact ? 'justify-center h-[48px]' : 'px-[14px]',
                className,
            )}
        >
            <AndroidSvg width={24} height={24} className={'shrink-0'}/>
            {compact ? null : (
                <>
                    <span className={'flex-1 min-w-0'}>
                        <span className={'block truncate text-text-strong font-semibold text-[13px] leading-[18px]'}>
                            {t('AppDownload.title')}
                        </span>
                        <span className={'block truncate text-[#D3B887] text-[10px] leading-[14px] mt-[2px]'}>
                            {t('AppDownload.subtitle')}
                        </span>
                    </span>
                    <DownloadSvg className={'shrink-0'}/>
                </>
            )}
        </a>
    );
};
